var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Enterprise Home"}},[_c('NavGroups',{attrs:{"items":_vm.items,"access":_vm.access,"block":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }